import React, { Component } from 'react';
import MuiPhoneNumber from 'material-ui-phone-number';
import { withStyles } from '@material-ui/core/styles';
import parsePhoneNumber from 'libphonenumber-js';
import styles from 'assets/jss/material-dashboard-pro-react/components/customPhoneLabelStyle';

class CustomPhoneLabel extends Component {
	render() {
		const {
			classes,
			value,
		} = this.props;

		const parsedPhoneNumber = parsePhoneNumber(`+${value}`);
		const country = (parsedPhoneNumber?.country || 'us').toLowerCase();

		return (
			<div className={classes.customPhoneLabelWrapper}>
				<MuiPhoneNumber
					className="customPhoneLabel"
					value={value}
					disabled
					disableAreaCodes={true}
					dropdownClass="modal-dropdown"
					defaultCountry={country}
					onlyCountries={[country]}
				/>
			</div>
		);
	}
}

export default withStyles(styles)(CustomPhoneLabel);
